export default __webpack_public_path__ + "static/media/rotterdamMinia.7b885719.png";